import React, { useEffect, useRef, useState } from 'react'
import * as E from '../elementor'
import { TestimonialT } from '../elementor/testimonial-widget'
import 'plyr/dist/plyr.css';
import Modal from './content/modal';
import VideoPlayButton from './video-play-button';

interface Props {
  section: E.Section
}

export const BlockReviews: React.FC<Props> = ({ section }) => {
  const [video1Open, setVideo1Open] = useState<boolean>(false);
  const [video2Open, setVideo2Open] = useState<boolean>(false);
  const { textEditor, testimonial, button, image, heading, video } = E.collect(section)
  const [subheadline] = textEditor

  // We need a .mov for Safari, a .webm for other browsers, and a youtube link for the popup for both of the video spots
  const hasVideos = video.length === 6;

  const videoPlayerRef1 = useRef<HTMLDivElement>(null);
  const videoPlayerRef2 = useRef<HTMLDivElement>(null);
  // using any here bc we don't import Plyr until client is ready
  const playerInstance1 = useRef<any>(null);
  const playerInstance2 = useRef<any>(null);
  const loopedVideo1 = useRef<HTMLVideoElement>(null);
  const loopedVideo2 = useRef<HTMLVideoElement>(null);

  const openVideo = (vid: 1 | 2) => {
    vid === 1 ? setVideo1Open(true) : setVideo2Open(true);
  }

  const video1 = 
  <div className="plyr__video-embed" ref={videoPlayerRef1} >
    <iframe
      src={video[4]?.youtube_url}
      allowFullScreen
      allowTransparency
      allow="autoplay"
      title="video 1"
    />
</div>;

  const video2 = 
  <div className="plyr__video-embed" ref={videoPlayerRef2} >
    <iframe
      src={video[5]?.youtube_url}
      allowFullScreen
      allowTransparency
      allow="autoplay"
      title="video 1"
    />
</div>;

  useEffect(() => {
    // checks that we're not in the server & that the video exists
    if (hasVideos && typeof window !== 'undefined' && typeof document !== 'undefined') {
      const Plyr = require('plyr');
      playerInstance1.current = new Plyr(videoPlayerRef1.current as HTMLDivElement, {
        controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'settings', 'fullscreen'],
      });

      playerInstance2.current = new Plyr(videoPlayerRef2.current as HTMLDivElement, {
        controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'settings', 'fullscreen'],
      });

      return () => {
        playerInstance1.current?.destroy();
        playerInstance2.current?.destroy();
      };
    }
  }, [video1Open, video2Open]);

  useEffect(() => {
    if (video1Open || video2Open) {
      loopedVideo1.current?.pause();
      loopedVideo2.current?.pause();
    } else {
      loopedVideo1.current?.play();
      loopedVideo2.current?.play();
    }
  }, [video1Open, video2Open]);

  const getMedia = (idx: number, review: TestimonialT) => {
    switch (true) {
      case hasVideos && idx === 0:
        return <div className={'image-' + idx.toString() + ' video-wrapper'} onClick={() => openVideo(1)}>
          <video autoPlay muted loop playsInline style={{ borderRadius: '10px'}} ref={loopedVideo1}>
            <source src={video[0].hosted_url} type='video/mp4' />
            <source src={video[1].hosted_url} type='video/webm' />
          </video>
          <VideoPlayButton />
        </div>
      case hasVideos && idx === 2:
        return <div className={'image-' + idx.toString() + ' video-wrapper'} onClick={() => openVideo(2)}>
          <video autoPlay muted loop playsInline style={{ borderRadius: '10px'}} ref={loopedVideo2}>
            <source src={video[2].hosted_url} type='video/mp4' />
            <source src={video[3].hosted_url} type='video/webm' />
          </video>
          <VideoPlayButton />
        </div>
      default:
        return <img className={'image-' + idx.toString()} src={review?.image?.url} alt='' />
    }
  }

  return (
    <div className='block-reviews'>
      <div className='block-reviews-content'>
        {image[0] &&
          <img className='block-reviews-icon' src={image[0]?.image?.fileUrl} alt='' />}
        <h2 className='headline'>
          {heading[0]?.title}
        </h2>
        <p className='paragraph subheadline'>
          {subheadline?.parse()}
        </p>
        {button[0] &&
          <a id={button[0]?.button_css_id || ''} href={button[0]?.link}>
            <button className='rula-button sky'>{button[0]?.text}</button>
          </a>}
        {!button[0] &&
          <div className='spacer' />}
      </div>
      <div className='review-wrapper'> 
        <div className='reviews'>
          {
              testimonial[0]?.testimonials.map((review, idx) => {
                return (
                  <>
                    <div className={'review review-' + idx.toString()}>
                      <blockquote className='subhead s5 content'>
                        {review.content}
                      </blockquote>
                      <div className='patient-info'>
                        <p className='paragraph-bold name'>
                          {review.name}
                        </p>
                        <p className='paragraph-bold title'>
                          {review.title}
                        </p>
                      </div>
                    </div>
                  {getMedia(idx, review)}
                </>
              )
            })
          }
        </div>
      </div>
      {hasVideos && video1Open && <Modal
        setDismissalState={setVideo1Open}
        mainContent = {video1}
      />}
      {hasVideos && video2Open && <Modal
        setDismissalState={setVideo2Open} 
        mainContent = {video2}
      />}
    </div>
  )
}

export default BlockReviews
